import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from  './../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private _authService:AuthService,private router: Router) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this._authService.isLoggedIn()) {
      return false;
      this.router.navigate(['/login']); // Redirect to the login page or any other appropriate page
      return false;
    }else{
      const expirationTime:any = localStorage.getItem("expirationTime");
      const currentTime = new Date().getTime();
      if (expirationTime && currentTime > expirationTime) {
        this._authService.logout();
        this.router.navigate(['/']);
        return false;
      }
      return this._authService.isLoggedIn();
    }
  }

}
